import scrollBreakpoints from './classes/scrollBreakpoints';
import { onDomReady } from './includes/utils';
import HorizontalList from './classes/HorizontalList';
import EmbeddedGallery from './classes/EmbeddedGallery';
import PerfectScrollbar from "./vendors/perfect-scrollbar-1.4/dist/perfect-scrollbar.esm";
import GMap from "./maps";
import './includes/scrollable';
import './proto/Window-getViewportDimensions';
import './proto/Element-getPosition';
import './scrollBehavior';

// web components 
import './components/tix02Notification';
//import './components/Toggle'; // input checkbox... but toggle ux



window.googleMaps = function(domID, centerPos, zoom) {
	return new GMap(domID, centerPos, zoom);
};



(function() {
	// Special Case 
	const gnh = document.querySelector('.global-nav-holder');
	const navHandler = document.querySelector('#nav-handler');
	if(! (gnh && navHandler) ) {
		return;
	}
	
	let gnhPS = null;
	const activeClassName = 'is-active';
	const activeBodyClassName = 'navigation-shown';
	
	
	const showNav = (event) => {
		document.body.classList.add(activeBodyClassName);
		event.currentTarget.querySelector('.hamburger').classList.add(activeClassName);
		if( gnh ) {
			gnhPS = new PerfectScrollbar(gnh);
		}
	};
	
	const hideNav = (event) => {
		document.body.classList.remove(activeBodyClassName);
		navHandler.querySelector('.hamburger').classList.remove(activeClassName);
		if( gnhPS ) {
			gnhPS.destroy();
			gnhPS = null;
		}
	}
		
	navHandler.addEventListener('click', event => {
		event.preventDefault();
		if( document.body.classList.contains(activeBodyClassName) ) {
			return hideNav(event);
		}
		return showNav(event);
	});
	
	
	document.querySelector('#nav-close-handler').addEventListener('click', event => {
		event.preventDefault();
		return hideNav(event);
	});
	
	
	const wpcf7Forms = document.querySelectorAll('.wpcf7');
	wpcf7Forms.forEach( form => {
		form.addEventListener('wpcf7submit', () => {
			if( typeof('gtag') === 'function' ) {
				gtag('event', 'conversion', {'send_to': 'AW-732883246/_mjACLCWrbQBEK7Su90C'});
			}
		}, false);
	});
}());


(function() {

	const cultureSelector = document.querySelector('.site-culture-selector');
	if( cultureSelector ) {
		document.querySelector('.site-culture-selector').addEventListener('click', event => {
			if( event.target.tagName.toUpperCase() === 'A' ) {
				return;
			}
			event.preventDefault();
			event.currentTarget.classList.toggle('shown');
		});
	}
	
	
	document.querySelectorAll('.wpcf7-form').forEach( form => {
		const subjectFld = form.querySelector('#subject');
		if(! subjectFld ) {
			return;
		}
			
		const s = getUrlParameter('_s');
		if( s ) {
			subjectFld.value = s;
		}
	});
})();








function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

	
	
(function() {
	onDomReady(() => {
		if( typeof(tarteaucitron) === 'undefined' ) {
			return;
		}
		
		var tarteaucitronForceLanguage = locale;
		tarteaucitron.init({
			'privacyUrl': privacy_url, 
			'hashtag': '#services-manager',
			'cookieName': 'servicesmanager',
		    
		    'orientation': 'bottom', /* Banner position (top - bottom) */
		    'showAlertSmall': false, /* Show the small banner on bottom right */
		    'cookieslist': true, /* Show the cookie list */
		
		    'adblocker': false, /* Show a Warning if an adblocker is detected */
		    'AcceptAllCta' : true, /* Show the accept all button when highPrivacy on */
		    'highPrivacy': true, /* Disable auto consent */
		    'handleBrowserDNTRequest': false, /* If Do Not Track == 1, disallow all */
		
		    'removeCredit': true, /* Remove credit link */
		    'moreInfoLink': true /* Show more info link */
	    });
	    
	    /*
		tarteaucitron.user.gtagUa = gTagUA;
		tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() * / };
		(tarteaucitron.job = tarteaucitron.job || []).push('gtag');
		*/
		tarteaucitron.user.multiplegtagUa = [gTagUA, 'AW-732883246'];
		(tarteaucitron.job = tarteaucitron.job || []).push('multiplegtag');
		
		tarteaucitron.user.googlemapsKey = gApiKey;
		(tarteaucitron.job = tarteaucitron.job || []).push('googlemaps');
		tarteaucitron.user.mapscallback = 'mapCallBack';
		
		tarteaucitron.user.googletagmanagerId = 'GTM-MZ8ZWDJ';
		(tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
		
		tarteaucitron.user.facebookpixelId = '3361649287240586'; 
		tarteaucitron.user.facebookpixelMore = function () { /* add here your optionnal facebook pixel function */ };
		(tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');
        
		tarteaucitron.user.linkedinadsPartnerId = '1718012';
		tarteaucitron.user.linkedinadsMore = function () { /* add here your optionnal linkedin ads function */ };
		(tarteaucitron.job = tarteaucitron.job || []).push('linkedinads');
		
		(tarteaucitron.job = tarteaucitron.job || []).push('typeform');
	});
})();


// having many gmaps in a single page 

window.addGoogleMap = function(callable) {
	
	if(! window.mapCallBack ) {
		window.mapCallBack = function() {
			window[callable]();	
		}
		return;
	}
	
	const ocb = window.mapCallBack;
	window.mapCallBack = function() {
		window[callable]();	
		ocb();
	};
	
	return;
};


/*
 * Scrolling breakpoints 
 */
(function() {
	const breakPoints = [
		{ 
			breakpoint: 120,
			callBack: {
				UP: function(element) {
					document.querySelector('.site-top-bar').classList.remove('min');
					document.querySelector('body').classList.remove('scrolled');
					document.querySelector('.site-controls').classList.remove('min');
				},
				
				DOWN: function(element) {
					document.querySelector('.site-top-bar').classList.add('min');
					document.querySelector('body').classList.add('scrolled');
					document.querySelector('.site-controls').classList.add('min');
				}
			}
		},
		/*
		{
			breakpoint: 120,
			callBack: {
				UP: function(element) {
					document.querySelector('.site-controls').classList.remove('min');
				},
				
				DOWN: function(element) {
					document.querySelector('.site-controls').classList.add('min');
				}
			}
		}
		*/
	];
	
	const scrollBP = new scrollBreakpoints(breakPoints);
	
	scrollBP.addBreakpoint({ 
		breakpoint: document.querySelectorAll('.fade-in'),
		callBack: {
			DOWN: function() {
				this.element.classList.add('shown');
			}
		}
	});
	
	
	const centreControlBar = document.querySelector('.centre-control-bar');
	if( centreControlBar ) {
			
		scrollBP.addBreakpoint({ 
			breakpoint: document.querySelector('.site-footer'),
			callBack: {
				DOWN: function() {
					centreControlBar.classList.add('hidden');
				},
				UP: function() {
					centreControlBar.classList.remove('hidden');
				}
			}
		});
		
	};
})();





/*
 * Centres H list
 */
 
(function() {
	 
	const centreList = document.getElementById('centres-list-hscroll');
	if( centreList ) {
		new HorizontalList( centreList );
	}
	
	
	const meetingRooms = document.querySelectorAll('.centre-meeting-rooms .hl-wrapper');
	meetingRooms.forEach( mr => {
		new HorizontalList(mr);
	});
	
	/*
	const testimonialsList = new HorizontalList(document.querySelector('#testimonials-horizontal-list .items-list'), {
		buttonPrev: '#testimonials-nav-prev',
		buttonNext: '#testimonials-nav-next',
		items: '.item',
		prop: 'translateX'
	});
	*/
})(); 




(function(){
	var thumbsList = document.querySelectorAll('.eg--embedded-gallery');
	thumbsList.forEach(list => {
		new EmbeddedGallery(list);
	});
}());
 
 
 
 
(function() {
	const table = document.getElementById('comparaison-chart');
	const buttons = document.querySelector('.comparaison-chart-controls .ccc-buttons');
	if(! (table && buttons))
		return;
		
	const baseClassName = 'view-category-';
	let currentSelection = false;
	
	buttons.querySelectorAll('.ccc-button').forEach( (btn, index) => {
		const _onClick = event => {
			if( currentSelection ) {
				const oldClassName = baseClassName + currentSelection;
				table.classList.remove(oldClassName);
				const oldSelected = buttons.querySelector('.selected');
				if( oldSelected )
					oldSelected.classList.remove('selected');
			}
			
			currentSelection = event.currentTarget.dataset.category;
			const className = baseClassName + currentSelection;
			
			table.classList.add(className);
			event.currentTarget.parentNode.classList.add('selected');
		};
		
		btn.addEventListener('click', _onClick);
		
		if( index === 0 )
			btn.dispatchEvent(new Event('click'));
	});
})();





// Anchors links 
(function() {
	const mask = /#[a-z0-9\-_]+/i;
	
	document.querySelectorAll('a[href*=\\#]').forEach(a => {
		const results = mask.exec(a.getAttribute('href'));
		if(! results || results.length === 0 ) {
			return;
		}
		try {
			if(! document.querySelector(results[0])) {
				return;
			}
			
			a.dataset.ref = results[0];
			a.addEventListener('click', event => {
				event.preventDefault();
				document.querySelector(event.currentTarget.dataset.ref).scrollIntoView({ behavior: 'smooth' });
				
			});
		} catch(error) {}
	});
}());